// export const BASE_URL =
//   process.env.NODE_ENV === 'develeopment' ? 'http://localhost:5000' : '';
export const BASE_URL = ''; // If using proxy
export const CATEGORIES_URL = '/api/categories';
export const USERS_URL = '/api/users';
export const PRODUCTS_URL = '/api/products';
export const SUBCATEGORIES_URL = '/api/subcategories';
export const GSTGROUPS_URL = '/api/gstGroups';
export const GSTROUTES_URL = '/api/gstroutes';
export const ORDERS_URL = '/api/Orders';
export const SUPPLIERS_URL = '/api/suppliers';
// const SUPPLIERS_URL = 'http://localhost:5000/api/suppliers';

export const CUSTOMERS_URL = '/api/customers';
export const HOLDINGSALESORDER_URL = '/api/holding-sales-orders';
export const NOTIFICATIONS_URL = '/api/notifications';
export const INFORMATIONS_URL = '/api/informations';
